import { IOrderManagementFilterBody, IOrderManagementStatsFilterBody } from "@/api_framework/api_modals/Orders";
import { useOrderManagementOrderListAPI } from "@/app/hooks/api_hooks/orders/useOrderListAPI";
import { useOrderManagementOrderUpdateAPI } from "@/app/hooks/api_hooks/orders/useOrderManagementActionAPI";
import { useOrderManagementStatsAPI } from "@/app/hooks/api_hooks/orders/useOrderStatsAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import {
  IOrderManagementState,
  setIsUserPopupModalActive,
} from "@/app_redux/reducers/slices/auth/order_management_slice";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

export interface IRotaFiltersFormFields {
  name?: string;
  cancelreason?: string;
  cancel_reason_name?: string;
}
export interface ActionBodyForProps {
  sub_order_id?: string;
  internal_order_status?: string;
  cancel_reason?: any;
}

export default function InitiateReturnProcess({
  buttonName,
  orders,
  buttonClassName = "",
  hideTrigger = false,
  controlledOpen = undefined,
  onControlledOpenChange = undefined,
}) {
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);
  const dispatch = useDispatch();
  const { orderFilter, orderModule } = routeState.state as IOrderManagementState;
  const [openInternal, setOpenInternal] = useState(false);
  const { execute: updateOrdersAPI } = useOrderManagementOrderUpdateAPI();
  const fetchOrderListAPI = useOrderManagementOrderListAPI();
  const fetchStatsAPI = useOrderManagementStatsAPI();
  const open = controlledOpen ?? openInternal;

  const setModalOpen = (nextOpen: boolean) => {
    if (typeof controlledOpen === "undefined") {
      setOpenInternal(nextOpen);
    }
    onControlledOpenChange?.(nextOpen);
  };

  useEffect(() => {
    if (open) {
      dispatch(setIsUserPopupModalActive(true));
    } else {
      dispatch(setIsUserPopupModalActive(false));
    }
  }, [open]);

  const cancelButtonRef = useRef(null);

  const handelSubmit = () => {
    const constructedBody = {
      sub_order_id: orders?.order_details?.sub_order_id,
      internal_order_status: "undelivered_in_transit",
    };
    const statsBody: IOrderManagementStatsFilterBody = {
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      clinic_id: orderFilter?.clinic_id?.split(","),
    };
    const requestBody: IOrderManagementFilterBody = {
      clinic_id: orderFilter?.clinic_id?.split(","),
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      order_status: "",
      source: orderModule,
      // ...(orderSource && { order_source: orderSource }),
      // page_number: page,
      // page_size: 20,
      // ...(isCentralRole && { for_central: "true" }),
    };
    updateOrdersAPI(constructedBody as any).then(({ status }) => {
      if (status) {
        (fetchOrderListAPI(requestBody), fetchStatsAPI(statsBody));
        setModalOpen(false);
      }
    });
  };

  return (
    <div>
      {!hideTrigger && (
        <button
          onClick={() => setModalOpen(true)}
          className={
            buttonClassName ||
            "w-full rounded-lg bg-black px-3 py-2 text-xs font-medium text-white transition-opacity hover:opacity-90"
          }
        >
          {buttonName}
        </button>
      )}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={() => setModalOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform overflow-visible rounded-xl bg-white p-5 text-left shadow-2xl transition-all sm:my-4 
                sm:max-w-md sm:w-full sm:p-6`}
                >
                  <Dialog.Title className="text-base font-semibold text-black">Initiate Return</Dialog.Title>
                  <p className="mt-2 text-sm text-gray-600">Are you sure you want to initiate return for this order?</p>
                  <div className="mt-5 flex justify-end gap-3">
                    <button
                      className="rounded-lg bg-[#F1F1F1] px-4 py-2 text-xs font-medium text-[#111827] transition-colors hover:bg-[#E5E7EB]"
                      onClick={() => setModalOpen(false)}
                    >
                      No
                    </button>
                    <button
                      onClick={() => handelSubmit()}
                      className="rounded-lg bg-black px-4 py-2 text-xs font-medium text-white transition-opacity hover:opacity-90"
                    >
                      Yes, Initiate
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
